import * as React from 'react';
import {connect} from 'react-redux';
import {Attribute} from '../models/Attribute';
import {EVENTS} from '../../../config/boCore';
import {
    createBusinessObjectAttribute,
    deleteBusinessObjectAttribute,
    updateBusinessObjectAttribute,
    convertBusinessObjectAttributeType
} from '../../../actions/boCoreActions';
import * as toastr from "toastr";
import {DataTypesEnum} from "../enums/dataTypesEnum";
import {BusinessObject} from "../models/BusinessObject";
import BusinessObjects from "../../../views/bo-core/BusinessObjects";
import {AttributeTypeEnum} from "../enums/AttributeTypeEnum";
import {numberComparator, stringComparator} from "../common/slickGridComparators";
import moment from "moment";
import LookUpConfigModal from "../modals/LookUpConfigModal";
import Utils from "../../../Utils";
import IncrementingConfigModal from "../modals/IncrementingConfigModal";

const lastEditableCol = 16, firstEditableCol = 1;

const PSQL_TYPES = new Set([
    AttributeTypeEnum.TEXT,
    AttributeTypeEnum.INT,
    AttributeTypeEnum.DATE,
    AttributeTypeEnum.DECIMAL,
    AttributeTypeEnum.TIME,
    AttributeTypeEnum.TIMESTAMP,
    AttributeTypeEnum.VALUE_LIST,
    AttributeTypeEnum.JSON,
    AttributeTypeEnum.INCREMENTING,
    AttributeTypeEnum.LOOKUP,
    AttributeTypeEnum.EMAIL,
    AttributeTypeEnum.BOOLEAN
]);

interface Props {
    currentAttribute: any;
    currentBusinessObject: any;

    createBusinessObjectAttribute(dto: any, args: any): void;

    updateBusinessObjectAttribute(id: number, dto: any, args: any): void;

    convertBusinessObjectAttributeType(id: number, dto: any, args: any): void;

    deleteBusinessObjectAttribute(id: number, dto: any): void;
}

interface State {
    grid: any
}

declare const Slick: any;

class BusinessObjectBusinessObjectAttributesGrid extends React.Component<Props, State> {
    lookUpConfigRef;
    incrementingConfigRef;

    constructor(props) {
        super(props);
        this.state = {
            grid: null
        }
    }

    UNSAFE_componentWillMount() {
        $(document.body)
            .unbind(EVENTS.boView.attributesGrid.open)
            .unbind(EVENTS.boView.attributesGrid.create)
            .unbind(EVENTS.boView.attributesGrid.update)
            .unbind(EVENTS.boView.attributesGrid.delete)
            .on(EVENTS.boView.attributesGrid.open, (event: any) => {
                this.buildGrid(this.props.currentBusinessObject, event.args.attrId);
                event.preventDefault();
            })
            .on(EVENTS.boView.attributesGrid.create, (event: any) => {
                const grid = $("#BusinessObjectAttributesGrid").data("gridInstance");
                const dataView = grid.getData();
                const businessObject = event.args.data;
                const attribute = businessObject.getAttribute(event.args.id);

                dataView.beginUpdate();
                dataView.deleteItem(-1);
                dataView.insertItem(0, attribute.clone());
                dataView.endUpdate();

                if (event.args.withNewRow) {
                    addNewRow(grid, businessObject);
                } else {
                    const row = dataView.getRowById(event.args.id);
                    setTimeout(() => {
                        grid.setSelectedRows([row]);
                        BusinessObject.enableButton("attributes-new-btn");
                    }, 1);
                }
                event.preventDefault();
                setTimeout(() => {
                    Utils.eventDispatcher(EVENTS.boView.setBusinessObject, {
                        businessObject: businessObject.clone()
                    });
                    BusinessObject.disableButton("attributes-save-btn");
                });
            })
            .on(EVENTS.boView.attributesGrid.update, (event: any) => {
                const grid = $("#BusinessObjectAttributesGrid").data("gridInstance");
                const dataView = grid.getData();
                const currentAttribute = this.props.currentBusinessObject.getAttribute(event.args.attribute.id);
                const row = dataView.getRowById(currentAttribute.id);

                currentAttribute.update(event.args.attribute);

                dataView.beginUpdate();
                dataView.updateItem(currentAttribute.id, currentAttribute.clone());
                dataView.endUpdate();
                grid.invalidateRow(row);
                event.preventDefault();
                setTimeout(() => {
                    grid.setSelectedRows([row]);
                    grid.render();
                });
            })
            .on(EVENTS.boView.attributesGrid.delete, (event: any) => {
                this.props.currentBusinessObject.deleteAttribute(event.args.id);
                const grid = $("#BusinessObjectAttributesGrid").data("gridInstance");
                const dataView = grid.getData();
                const row = dataView.getRowById(event.args.id);
                dataView.beginUpdate();
                dataView.deleteItem(event.args.id);
                dataView.endUpdate();
                grid.invalidateRow(row);
                event.preventDefault();
                setTimeout(() => {
                    grid.setSelectedRows([row]);
                    grid.render();
                });
            })
    }

    buildGrid = (businessObject, attrId) => {
        let grid, dataView, self = this;
        const data = businessObject.getAttributes(DataTypesEnum.ARRAY).map(item => item.clone());
        let columnFilters = {};

        let radioSelector = new Slick.RadioSelectColumn({
            cssClass: "slick-cell-checkboxsel",
            columnId: "attribute-grid-checkbox"
        });

        const columns = [
            radioSelector.getColumnDefinition(),
            {
                id: "name",
                name: "Name",
                field: "name",
                width: 150,
                minWidth: 50,
                sortable: true,
                editor: TextEditor
            },
            {
                id: "description",
                name: "Description",
                field: "description",
                width: 250,
                defValue: 'n/a',
                minWidth: 50,
                sortable: true,
                editor: TextEditor
            },
            {
                id: "type",
                name: "Type",
                field: "type",
                width: 100,
                minWidth: 50,
                sortable: true,
                editor: PSQLEditor,
                dataSource: Array.from(PSQL_TYPES)
            },
            {
                id: "unitOfMeasure",
                name: "Unit Of Measure",
                field: "unitOfMeasure",
                defValue: 'n/a',
                width: 100,
                minWidth: 50,
                sortable: true,
                editor: TextEditor
            },
            {
                id: "minLength",
                name: "Min ( Val / Length )",
                field: "minLength",
                width: 100,
                minWidth: 50,
                defValue: -1,
                sortable: true,
                editor: TextEditor
            },
            {
                id: "maxLength",
                name: "Max ( Val / Length )",
                field: "maxLength",
                width: 100,
                defValue: -1,
                minWidth: 50,
                sortable: true,
                editor: TextEditor
            },
            {
                id: "maxDigitsLeftOfDecimal",
                name: "Max Digits Left",
                field: "maxDigitsLeftOfDecimal",
                width: 100,
                defValue: -1,
                minWidth: 50,
                sortable: true,
                editor: TextEditor
            },
            {
                id: "minDigitsRightOfDecimal",
                name: "Min Digits Right",
                field: "minDigitsRightOfDecimal",
                width: 100,
                defValue: -1,
                minWidth: 50,
                sortable: true,
                editor: TextEditor
            },
            {
                id: "regexValidation",
                name: "Regex Validation",
                field: "regexValidation",
                width: 100,
                defValue: '.*',
                minWidth: 50,
                sortable: true,
                editor: TextEditor
            },
            {
                id: "uiSection",
                name: "UI Section",
                field: "uiSection",
                width: 100,
                defValue: 'main',
                minWidth: 50,
                sortable: true,
                editor: TextEditor
            },
            {
                id: "prefix",
                name: "Prefix",
                field: "prefix",
                width: 100,
                defValue: 'n/a',
                minWidth: 50,
                sortable: true,
                editor: TextEditor
            },
            {
                id: "suffix",
                name: "Suffix",
                field: "suffix",
                defValue: 'n/a',
                width: 100,
                minWidth: 50,
                sortable: true,
                editor: TextEditor
            },
            {
                id: "defaultValue",
                name: "Default Value",
                field: "defaultValue",
                width: 120,
                minWidth: 50,
                sortable: true,
                formatter: Formatter,
                editor: DefaultValueEditor
            },
            {
                id: "receiveNotifications",
                name: "Send Change Notifications",
                field: "receiveNotifications",
                width: 135,
                sortable: true,
                resizable: false,
                editor: SwitchEditor,
                formatter: emailFormatter
            },
            {
                id: "required",
                name: "Required",
                field: "required",
                width: 55,
                sortable: true,
                resizable: false,
                editor: SwitchEditor
            },
            {
                id: "systemRequired",
                name: "System Required",
                field: "systemRequired",
                width: 90,
                sortable: true,
                resizable: false,
                editor: SwitchEditor
            },
        ];

        const options = {
            enableCellNavigation: true,
            enableColumnReorder: false,
            forceFitColumns: true,
            multiColumnSort: false,
            editable: true,
            showHeaderRow: true,
            headerRowHeight: 30,
            explicitInitialization: true
        };

        function emailFormatter(row, cell, value, columnDef, dataContext) {
            if (dataContext.type === AttributeTypeEnum.EMAIL) {
                return value
            }
            return '';
        }

        function Formatter(row, cell, value, columnDef, dataContext) {
            if (dataContext.type === AttributeTypeEnum.VALUE_LIST) {
                return dataContext.attributeValues.get(Number(value)) ? dataContext.attributeValues.get(Number(value)).name : "-1";
            }
            if (dataContext.type === AttributeTypeEnum.EMAIL) {
                return Utils.parseEmailAttributeDefaultValueNames(value, dataContext.attributeValues);
            }
            return value
        }

        function filter(item) {
            const keys = Object.keys(columnFilters);
            for (let i = 0; i < keys.length; i++) {
                if (columnFilters[keys[i]] !== "") {
                    const c = grid.getColumns()[grid.getColumnIndex(keys[i])];
                    if (!item[c.field].toString().toLowerCase().includes(columnFilters[keys[i]].toString().toLowerCase())) {
                        return false;
                    }
                }
            }
            return true;
        }

        const getCurrentAttribute = () => {
            return this.props.currentAttribute;
        };
        const getCurrentBusinessObject = () => {
            return this.props.currentBusinessObject;
        };

        function SwitchEditor(args) {
            let $input, defaultValue;
            this.init = function () {
                $input = $("<input id='toggle-one' type='checkbox' data-onstyle='primary' data-offstyle='danger' data-toggle='toggle' data-size='mini' />");
                $input.appendTo(args.container);
                $input.focus().select();
                $input.width($input.width());
                $input.keydown(function (e) {
                    if (e.keyCode === Utils.$.ui.keyCode.LEFT || e.keyCode === Utils.$.ui.keyCode.RIGHT) {
                        e.stopImmediatePropagation();
                    }
                });

                $input.prop('checked', args.item[args.column.field]);

                $input.bootstrapToggle({
                    on: 'true',
                    off: 'false'
                });

                $input.change(() => {
                    const currentAttribute = getCurrentAttribute();
                    const currentBusinessObject = getCurrentBusinessObject();
                    const originalAttribute = currentBusinessObject.getAttribute(currentAttribute.id);
                    if (originalAttribute && args.column.field === "systemRequired" && originalAttribute.systemRequired && !$input[0].checked) {
                        Utils.$.confirm({
                            title: 'Confirm?',
                            keyboardEnabled: true,
                            escapeKey: 'cancel',
                            backgroundDismiss: false,
                            content: 'Unlocking this Attribute may cause problem with some functionalities. Are you sure you want to continue?',
                            type: 'red',
                            theme: 'dark',
                            typeAnimated: false,
                            buttons: {
                                ok: {
                                    text: "Yes!",
                                    btnClass: 'btn-danger',
                                    keys: ['enter'],
                                    action: () => {
                                        setRequired();
                                        self.saveBoClassAttribute(true);
                                    }
                                },
                                cancel: function () {
                                    $input.bootstrapToggle("toggle")
                                }
                            }
                        });
                    } else {
                        setRequired()
                    }

                    function setRequired() {
                        currentAttribute[args.column.field] = $input[0].checked;
                        const result = currentBusinessObject.checkAttributesBeforeSave(currentAttribute);
                        BusinessObjects.appendQtipsToNode(result.data, grid, $("#attributes-save-btn"));
                        if (!result.valid) {
                            BusinessObject.disableButton("attributes-save-btn");
                            return
                        }
                        BusinessObject.enableButton("attributes-save-btn", "");
                    }
                });

                this.focus = function () {
                    $input.focus();
                };
                this.destroy = function () {
                    $(args.container).empty();
                };
                this.isValueChanged = function () {
                    return args.item.input !== $input.val()
                };
                this.loadValue = function (item) {
                    defaultValue = item[args.column.field];
                    $input.val(defaultValue);
                    $input.select();
                };
                this.serializeValue = function () {
                    return {input: $input.val()}
                };
                this.applyValue = function (item) {
                    item[args.column.field] = $input[0].checked;
                };
                this.validate = function () {
                    return {valid: true, msg: null}
                };
            };
            this.init();
        }

        function PSQLEditor(args) {
            let $input, defaultValue;
            this.keyCaptureList = [Slick.keyCode.UP, Slick.keyCode.DOWN, Slick.keyCode.ENTER];
            this.init = function () {
                $input = $('<select/>');
                $input.appendTo(args.container);
                PopulateSelect($input[0], args.column.dataSource, true);
                $input.keydown(function (e) {
                    if (e.keyCode === Utils.$.ui.keyCode.LEFT || e.keyCode === Utils.$.ui.keyCode.RIGHT) {
                        e.stopImmediatePropagation();
                    }
                });
                $input.select2({
                    width: $(args.container).width(),
                    placeholder: 'Select PSQL Type',
                    allowClear: false,
                    theme: "default"
                });

                $input.select2("focus");

                $input.change(function (e) {
                    const currentAttribute = getCurrentAttribute();
                    const currentBusinessObject = getCurrentBusinessObject();
                    currentAttribute.type = e.val;

                    grid.getEditorLock().commitCurrentEdit();
                    grid.setActiveCell(grid.getSelectedRows()[0], 3);

                    const result = currentBusinessObject.checkAttributesBeforeSave(currentAttribute);
                    BusinessObjects.appendQtipsToNode(result.data, grid, $("#attributes-save-btn"));
                    if (!result.valid) {
                        BusinessObject.disableButton("attributes-save-btn");
                        return
                    }
                    BusinessObject.enableButton("attributes-save-btn", "");
                    self.forceUpdate();
                });
                this.focus = function () {
                    $input.focus();
                };
                this.destroy = function () {
                    $input.select2('destroy');
                    $input.remove();
                };

                this.isValueChanged = function () {
                    return (!($input.val() === "" && defaultValue == null)) && ($input.val() !== defaultValue);
                };

                this.loadValue = function (item) {
                    defaultValue = item[args.column.field];
                    $input.val(defaultValue);
                    $input[0].defaultValue = defaultValue;
                    item._receiveNotifications = item._type !== AttributeTypeEnum.EMAIL ? '' : false;
                    $input.trigger("change.select2");
                };

                this.serializeValue = function () {
                    return {input: $input.val()}
                };

                this.applyValue = function (item) {
                    const currentAttribute = getCurrentAttribute();
                    item[args.column.field] = currentAttribute[args.column.id];

                    if (item[args.column.field] === AttributeTypeEnum.LOOKUP) {
                        self.lookUpConfigRef.open(currentAttribute.lookupAttributeId, currentAttribute.lookupRelTypeId, currentAttribute.createRelationships, self.props.currentBusinessObject.id)
                    }
                };

                this.validate = function () {
                    return {valid: true, msg: undefined};
                };

            };
            this.init();
        }


        function DefaultValueEditor(args) {
            let $input, defaultValue;
            let calendarOpen = false;
            this.keyCaptureList = [Slick.keyCode.UP, Slick.keyCode.DOWN, Slick.keyCode.ENTER];

            this.init = function () {
                switch (args.item.type) {
                    case AttributeTypeEnum.VALUE_LIST: {
                        $input = $('<select style="position:absolute; top:0;"  class="border-blue"/>');
                        $input.appendTo(args.container);
                        PopulateDefaultSelect($input[0], args.item.getAttributeValues(DataTypesEnum.ARRAY));

                        $input.select2({
                            width: $(args.container).width(),
                            placeholder: 'Select Default Attribute Value',
                            allowClear: true,
                            theme: "default"
                        });

                        $input.select2("focus");

                        $input.change(function (e) {
                            updateBoAttrib(e.val);
                        });
                    }
                        break;
                    case AttributeTypeEnum.DATE: {
                        $input = $("<input style='position:absolute; top: 0;' type=text class='editor-text border-blue-input' />");
                        $input.appendTo(args.container);
                        $input.width(args.position.width - 2);
                        $input.height(args.position.height - 2);
                        $input.focus().select();
                        $input.flatpickr({
                            dateFormat: "Y-m-d",
                            allowInput: false,
                            defaultDate: args.item.defaultValue.toString().match(/(\d{4})-(\d{2})-(\d{2})/g) ? args.item.defaultValue : moment().format("YYYY-MM-DD"),
                            onChange: (dateText, date) => {
                                updateBoAttrib(date);
                            },
                            onOpen: function () {
                                $(this.daysContainer).children().children(".selected").focus();
                            },
                        });
                    }
                        break;
                    case AttributeTypeEnum.TIMESTAMP: {
                        $input = $("<input style='position:absolute; top:0;' type=text class='editor-text border-blue-input' />");
                        $input.appendTo(args.container);
                        $input.width(args.position.width - 2);
                        $input.height(args.position.height - 2);
                        $input.focus().select();
                        $input.flatpickr({
                            dateFormat: 'Y-m-dTH:i:S',
                            enableTime: true,
                            allowInput: false,
                            time_24hr: true,
                            defaultDate: args.item.defaultValue !== "n/a" ? args.item.defaultValue : moment().format("YYYY-MM-DDTHH:mm:ss"),
                            onOpen: function () {
                                calendarOpen = true;
                                $(this.daysContainer).children().children(".selected").focus();
                            },
                            onClose: function () {
                                calendarOpen = false;
                            },
                            onChange: (dateText, date) => {
                                updateBoAttrib(date);
                            }
                        });
                    }
                        break;
                    case AttributeTypeEnum.TIME: {
                        $input = $("<input style='position:absolute; top:0;' type=search class='editor-text border-blue-input' />");
                        $input.appendTo(args.container);
                        $input.width(args.position.width - 2);
                        $input.height(args.position.height - 2);
                        $input.focus().select();
                        $input.flatpickr({
                            enableSeconds: true,
                            enableTime: true,
                            noCalendar: true,
                            time_24hr: true,
                            defaultHour: args.item.defaultValue.toString().match(/(?:[01]\d|2[0-3]):(?:[0-5]\d):(?:[0-5]\d)/g) ? args.item.defaultValue.substr(0, 2) : "12",
                            defaultMinute: args.item.defaultValue.toString().match(/(?:[01]\d|2[0-3]):(?:[0-5]\d):(?:[0-5]\d)/g) ? args.item.defaultValue.substr(3, 2) : "00",
                            onChange: (dateText, time) => {
                                updateBoAttrib(time);
                            },
                        });
                        $(".numInput.flatpickr-hour").keydown(function (event) {
                            if (event.keyCode === 9 && event.shiftKey === true) {
                                event.preventDefault();
                            }
                        })
                    }
                        break;
                    case AttributeTypeEnum.JSON: {
                        $input = $("<textarea class='border-blue-input' style='width:100%;max-width:100%;min-width:100%;height:28px;max-height:150px;min-height:28px;position:absolute; top:0;'/>");
                        $input.appendTo(args.container);
                        $input.focusout(function () {
                            if (grid.getEditorLock().isActive()) {
                                grid.getEditorLock().commitCurrentEdit();
                            }
                        });
                        $input.keyup((e) => {
                            if (e.which !== 9) {
                                updateBoAttrib(e.target.value);
                            }
                        });
                    }
                        break;
                    case AttributeTypeEnum.TEXT:
                    case AttributeTypeEnum.EMAIL:
                    case AttributeTypeEnum.INCREMENTING: {
                        $input = $("<textarea class='border-blue-input' style='width:100%;max-width:100%;min-width:100%;height:28px;max-height:150px;min-height:28px;position:absolute; top:0;'/>");
                        $input.appendTo(args.container);
                        $input.focusout(function () {
                            if (grid.getEditorLock().isActive()) {
                                grid.getEditorLock().commitCurrentEdit();
                            }
                        });

                        $input.keyup((e) => {
                            if (e.which !== 9) {
                                updateBoAttrib(e.target.value);
                            }
                        });
                    }
                        break;
                    case AttributeTypeEnum.INT: {
                        $input = $("<input style='position:absolute; top:0;' type=text class='editor-text border-blue-input' />");
                        $input.appendTo(args.container);
                        $input.width(args.position.width - 2).height(args.position.height - 2);
                        $input.focusout(function () {
                            if (grid.getEditorLock().isActive()) {
                                grid.getEditorLock().commitCurrentEdit();
                            }
                        });
                        $input.keyup((e) => {
                            if (e.which !== 9) {
                                updateBoAttrib(e.target.value);
                            }
                        });
                    }
                        break;
                    case AttributeTypeEnum.DECIMAL: {
                        $input = $("<input style='position:absolute; top:0;' type=text class='editor-text border-blue-input' />");
                        $input.appendTo(args.container);
                        $input.width(args.position.width - 2).height(args.position.height - 2);
                        $input.focusout(function () {
                            if (grid.getEditorLock().isActive()) {
                                grid.getEditorLock().commitCurrentEdit();
                            }
                        });
                        $input.keyup((e) => {
                            if (e.which !== 9) {
                                updateBoAttrib(e.target.value.replace(",", "."));
                            }
                        });
                    }
                        break;
                    case AttributeTypeEnum.BOOLEAN: {
                        $input = $('<select style="position:absolute; top:0;"  class="border-blue"/>');
                        $input.appendTo(args.container);
                        const boolValues = [
                            {
                                name: 'n/a',
                                id: 'n/a'
                            },
                            {
                                name: 'true',
                                id: 'true'
                            },
                            {
                                name: 'false',
                                id: 'false'
                            },
                        ]
                        PopulateDefaultSelect($input[0], boolValues);

                        $input.select2({
                            width: $(args.container).width(),
                            placeholder: 'Select Default Attribute Value',
                            allowClear: true,
                            theme: "default"
                        });

                        $input.select2("focus");

                        $input.change(function (e) {
                            updateBoAttrib(e.val);
                        });
                    }
                }
                $input.keydown(function (e) {
                    if (e.keyCode === Utils.$.ui.keyCode.LEFT || e.keyCode === Utils.$.ui.keyCode.RIGHT) {
                        e.stopImmediatePropagation();
                    }
                });
                this.focus = function () {
                    $input.focus();
                };
                this.destroy = function () {
                    if (args.item.type === AttributeTypeEnum.VALUE_LIST) {
                        $input.select2('destroy');
                        $input.remove();
                        $(args.container).empty();
                    } else {
                        $input.remove();
                        $(args.container).empty();
                    }
                };
                this.isValueChanged = function () {
                    return (!($input.val() === "" && defaultValue == null)) && ($input.val() !== defaultValue);
                };
                this.loadValue = function (item) {
                    const val = item[args.column.field];
                    switch (item.type) {
                        case AttributeTypeEnum.TIMESTAMP:
                        case AttributeTypeEnum.TIME:
                        case AttributeTypeEnum.DATE:
                            $input.val(val);
                            break;
                        case AttributeTypeEnum.VALUE_LIST: {
                            $input.val(item.attributeValues.get(Number(item.defaultValue)) ? item.attributeValues.get(Number(item.defaultValue)).id : item.defaultValue);
                            $input.trigger("change.select2");
                            break;
                        }
                        case AttributeTypeEnum.EMAIL: {
                            $input.val(Utils.parseEmailAttributeDefaultValueNames(item.defaultValue, item.attributeValues));
                            $input.select();
                            break;
                        }
                        default:
                            if (args.column.name === 'Default Value') {
                                if (val !== -1 && val !== 'n/a' && val !== '{}') {
                                    defaultValue = val || "";
                                } else {
                                    defaultValue = "";
                                }
                                $input.val(defaultValue);
                                $input.select();
                            } else {
                                $input.val(val);
                                $input.select();
                            }
                    }
                };
                this.serializeValue = function () {
                    return {input: $input.val()}
                };
                this.applyValue = function (item) {
                    const currentAttribute = getCurrentAttribute();
                    item[args.column.field] = currentAttribute.defaultValue;
                };
                this.validate = function () {
                    return {valid: true, msg: null}
                };
            };
            this.init();
        }

        function updateBoAttrib(val) {
            const currentAttribute = getCurrentAttribute();
            const currentBusinessObject = getCurrentBusinessObject();
            if (val === '') {
                currentAttribute.defaultValue = Attribute._defValue;
            } else {
                currentAttribute.defaultValue = val;
            }
            const result = currentBusinessObject.checkAttributesBeforeSave(currentAttribute);
            BusinessObjects.appendQtipsToNode(result.data, grid, $("#attributes-save-btn"));
            if (!result.valid) {
                BusinessObject.disableButton("attributes-save-btn");
                return
            }
            BusinessObject.enableButton("attributes-save-btn", "");
        }

        function TextEditor(args) {
            let $input, defaultValue;
            this.init = function () {
                $input = $(`<input  type='search' class='editor-text rounded' />`);
                $input.appendTo(args.container);
                $input.focus().select();
                $input.width($input.width());
                $input.keydown(function (e) {
                    if (e.keyCode === Utils.$.ui.keyCode.LEFT || e.keyCode === Utils.$.ui.keyCode.RIGHT) {
                        e.stopImmediatePropagation();
                    }
                });

                $input.keyup(function (e) {
                    if (e.which !== 9) {
                        const currentAttribute = getCurrentAttribute();
                        const currentBusinessObject = getCurrentBusinessObject();
                        if (e.target.value !== "") {
                            currentAttribute[args.column.id] = e.target.value;
                        } else {
                            currentAttribute[args.column.id] = args.column.defValue;
                        }
                        const result = currentBusinessObject.checkAttributesBeforeSave(currentAttribute);
                        BusinessObjects.appendQtipsToNode(result.data, grid, $("#attributes-save-btn"));
                        if (!result.valid) {
                            BusinessObject.disableButton("attributes-save-btn");
                            return
                        }
                        BusinessObject.enableButton("attributes-save-btn", "");
                    }
                });

                this.focus = function () {
                    $input.focus();
                };
                this.destroy = function () {
                    $(args.container).empty();
                };
                this.isValueChanged = function () {
                    return (!($input.val() === "" && defaultValue == null)) && ($input.val() !== defaultValue);
                };
                this.loadValue = function (item) {
                    const val = item[args.column.field];
                    if (args.column.name === 'Name') {
                        defaultValue = val || "";
                    } else {
                        if (val !== -1 && val !== 'n/a' && val !== 'main' && val !== '{}' && val !== '.*') {
                            defaultValue = val || "";
                        } else {
                            defaultValue = "";
                        }
                    }

                    $input.val(defaultValue);
                    $input[0].defaultValue = defaultValue;
                    $input.select();
                };
                this.serializeValue = function () {
                    return {input: $input.val()}
                };
                this.applyValue = function (item) {
                    const currentAttribute = getCurrentAttribute();
                    item[args.column.field] = currentAttribute[args.column.id];
                };
                this.validate = function () {
                    const currentBusinessObject = getCurrentBusinessObject();
                    const currentAttribute = getCurrentAttribute();
                    switch (args.column.id) {
                        case "name": {
                            if (currentBusinessObject.hasAttributeByNameExceptId(currentAttribute.name, currentAttribute.id)) {
                                return {
                                    valid: false,
                                    msg: `Attribute with name: "${currentAttribute.name}" already exists.`
                                }
                            }
                        }
                            break;
                        case "minLength": {
                            if (isNaN(getCurrentAttribute().minLength)) {
                                return {valid: false, msg: "The attribute minLength is not a number."}
                            }
                        }
                            break;
                        case "maxLength": {
                            if (isNaN(getCurrentAttribute().maxLength)) {
                                return {valid: false, msg: "The attribute maxLength is not a number."}
                            }
                        }
                            break;
                        case "minDigitsRightOfDecimal": {
                            if (isNaN(getCurrentAttribute().minDigitsRightOfDecimal)) {
                                return {valid: false, msg: "The attribute minDigitsRightOfDecimal is not a number."}
                            }
                        }
                            break;
                        case "maxDigitsLeftOfDecimal": {
                            if (isNaN(getCurrentAttribute().maxDigitsLeftOfDecimal)) {
                                return {valid: false, msg: "The attribute maxDigitsLeftOfDecimal is not a number."}
                            }
                        }
                    }
                    return {valid: true, msg: undefined}
                };
            };
            this.init();
        }

        function attachAutoResizeDataGrid(grid, gridId) {
            const gridDomElm = $('#' + gridId);
            if (!gridDomElm || typeof gridDomElm.offset() === "undefined") {
                return null;
            }
            if ($(document.body).hasClass("mini-navbar")) {
                resizeToFitBrowserWindow(grid, gridId, true);
            } else {
                resizeToFitBrowserWindow(grid, gridId, false);
            }
            $("#hide-nav-btn").on("click", function () {
                if (!$(document.body).hasClass("mini-navbar")) {
                    resizeToFitBrowserWindow(grid, gridId, true);
                } else {
                    resizeToFitBrowserWindow(grid, gridId, false);
                }
            });
            $(window).on("resize", function () {
                if ($(document.body).hasClass("mini-navbar")) {
                    resizeToFitBrowserWindow(grid, gridId, true);
                } else {
                    resizeToFitBrowserWindow(grid, gridId, false);
                }
            });
        }

        function calculateNewDimensions(printMode, minNavBarEnabled) {
            const $accordeon = $("#accordeon");
            if (minNavBarEnabled) {
                return {
                    height: $accordeon.height() - 55,
                    width: "100%"
                }
            }

            return {
                height: $accordeon.height() - 55,
                width: "100%"
            }
        }

        function resizeToFitBrowserWindow(grid, gridId, minNavBarEnabled) {
            const newSizes = calculateNewDimensions(null, minNavBarEnabled);

            $('#' + gridId)
                .height(newSizes.height)
                .width(newSizes.width);

            if (new RegExp('MSIE [6-8]').exec(navigator.userAgent) === null && grid) {
                grid.resizeCanvas();
            }
        }

        function removeFilters() {
            columnFilters = {};
            let header = grid.getHeaderRow();
            $(header).children('div').each(function (index, element) {
                if (index !== 0) {
                    $(element).children().val("");
                }

            });
        }

        $(() => {
                const $businessObjectAttributesGrid = $("#BusinessObjectAttributesGrid");
                dataView = new Slick.Data.DataView();
                dataView.beginUpdate();
                dataView.setItems(data);
                dataView.setFilter(filter);
                dataView.endUpdate();

                if ($businessObjectAttributesGrid[0]) {
                    grid = new Slick.Grid("#BusinessObjectAttributesGrid", dataView, columns, options);
                    $businessObjectAttributesGrid.data("gridInstance", grid);
                    $businessObjectAttributesGrid.data("dataViewInstance", dataView);

                    grid.registerPlugin(radioSelector);

                    grid.onSort.subscribe(function (e, args) {
                        const currentAttribute = getCurrentAttribute();
                        const currentBusinessObject = getCurrentBusinessObject();
                        if (currentAttribute) {
                            if (currentBusinessObject.hasAttribute(currentAttribute.id)) {
                                const attribute = currentBusinessObject.getAttribute(currentAttribute.id);
                                if (!attribute.equal(currentAttribute)) {
                                    confirm(attribute);
                                } else {
                                    sort()
                                }
                            } else {
                                confirm();
                            }
                        } else {
                            sort();
                        }

                        function confirm(attribute?: any) {
                            Utils.$.confirm({
                                title: 'Confirm?',
                                keyboardEnabled: true,
                                escapeKey: 'cancel',
                                backgroundDismiss: false,
                                content: 'There are unsaved changes. Are you sure you want to continue?',
                                type: 'red',
                                theme: 'dark',
                                typeAnimated: false,
                                buttons: {
                                    ok: {
                                        text: "Yes!",
                                        btnClass: 'btn-danger',
                                        keys: ['enter'],
                                        action: () => {
                                            if (grid.getEditorLock().isActive()) {
                                                grid.getEditorLock().cancelCurrentEdit();
                                            }
                                            if (attribute) {
                                                currentAttribute.update(attribute);
                                            } else {
                                                dataView.beginUpdate();
                                                dataView.deleteItem(-1);
                                                Utils.eventDispatcher(EVENTS.boView.setAttribute, {
                                                    attribute: null
                                                });
                                                dataView.endUpdate();
                                                grid.setSelectedRows([]);
                                                BusinessObject.enableButton("attributes-new-btn");
                                            }
                                            sort();
                                        }
                                    },
                                    cancel: function () {

                                    }
                                }
                            });
                        }

                        function sort() {
                            const sortCol = args.sortCol;
                            dataView.sort(function (dataRow1, dataRow2) {
                                const field = sortCol.field;
                                const sign = args.sortAsc ? 1 : -1;

                                const value1 = dataRow1[field];
                                const value2 = dataRow2[field];
                                switch (field) {
                                    case "minLength":
                                    case "maxLength":
                                    case "maxDigitsLeftOfDecimal":
                                    case "minDigitsRightOfDecimal":
                                    case "sequence":
                                        return numberComparator(value1, value2, sign);
                                    default:
                                        return stringComparator(value1, value2, sign);
                                }
                            });
                            grid.invalidate();
                            grid.updateRowCount();
                            grid.resizeCanvas();
                            grid.render();
                        }
                    });

                    dataView.onRowCountChanged.subscribe(function () {
                        grid.invalidate();
                        grid.updateRowCount();
                        grid.resizeCanvas();
                        grid.render();
                    });

                    dataView.onRowsChanged.subscribe(function (e, args) {
                        grid.invalidateRows(args.rows);
                        grid.updateRowCount();
                        grid.resizeCanvas();
                        grid.render();
                    });


                    Utils.$(grid.getHeaderRow()).undelegate(":input", "keyup search");
                    Utils.$(grid.getHeaderRow()).delegate(":input", "keyup search", function () {
                        const columnId = $(this).data("columnId");
                        if (columnId != null) {
                            const currentAttribute = getCurrentAttribute();
                            const currentBusinessObject = getCurrentBusinessObject();
                            if (currentAttribute) {
                                if (currentBusinessObject.hasAttribute(currentAttribute.id)) {
                                    const attribute = currentBusinessObject.getAttribute(currentAttribute.id);
                                    if (!attribute.equal(currentAttribute)) {
                                        Utils.$.confirm({
                                            title: 'Confirm?',
                                            keyboardEnabled: true,
                                            escapeKey: 'cancel',
                                            backgroundDismiss: false,
                                            content: 'There are unsaved changes. Are you sure you want to continue?',
                                            type: 'red',
                                            theme: 'dark',
                                            typeAnimated: false,
                                            buttons: {
                                                ok: {
                                                    text: "Yes!",
                                                    btnClass: 'btn-danger',
                                                    keys: ['enter'],
                                                    action: () => {
                                                        if (grid.getEditorLock().isActive()) {
                                                            grid.getEditorLock().cancelCurrentEdit();
                                                        }
                                                        currentAttribute.update(attribute);

                                                        columnFilters[columnId] = Utils.$.trim($(this).val());
                                                        dataView.refresh();
                                                        grid.invalidate();
                                                        grid.render();
                                                    }
                                                },
                                                cancel: function () {
                                                }
                                            }
                                        });
                                    } else {
                                        columnFilters[columnId] = Utils.$.trim($(this).val());
                                        dataView.refresh();
                                    }
                                }
                            } else {
                                columnFilters[columnId] = Utils.$.trim($(this).val());
                                dataView.refresh();
                            }
                        }
                    });
                    grid.onHeaderRowCellRendered.subscribe(function (e, args) {
                        $(args.node).empty();
                        if (args.column.id !== "attribute-grid-checkbox") {
                            $(`<input class=rounded type='search' placeholder="🔍">`)
                                .data("columnId", args.column.id)
                                .val(columnFilters[args.column.id])
                                .appendTo(args.node);
                        }
                    });

                    grid.onSelectedRowsChanged.subscribe((e) => {
                        const row = grid.getSelectedRows()[0];
                        const item = dataView.getItem(row);
                        if (item) {
                            Utils.eventDispatcher(EVENTS.boView.setAttribute, {
                                attribute: item.clone()
                            });
                        } else {
                            Utils.eventDispatcher(EVENTS.boView.setAttribute, {
                                attribute: null
                            });
                        }
                        BusinessObject.disableButton("attributes-save-btn");
                        Utils.$(".qtip").remove();
                        Utils.$('[data-hasqtip]').qtip('destroy', true);
                        e.stopPropagation();
                        e.stopImmediatePropagation();
                    });

                    grid.onBeforeRowChange = function (e, args) {
                        const currentAttribute = getCurrentAttribute();
                        const currentBusinessObject = getCurrentBusinessObject();
                        if (currentAttribute) {
                            if (currentBusinessObject.hasAttribute(currentAttribute.id)) {
                                const attribute = currentBusinessObject.getAttribute(currentAttribute.id);
                                if (!attribute.equal(currentAttribute)) {
                                    Utils.$.confirm({
                                        title: 'Confirm?',
                                        keyboardEnabled: true,
                                        escapeKey: 'cancel',
                                        backgroundDismiss: false,
                                        content: 'There are unsaved changes. Are you sure you want to continue?',
                                        type: 'red',
                                        theme: 'dark',
                                        typeAnimated: false,
                                        buttons: {
                                            ok: {
                                                text: "Yes!",
                                                btnClass: 'btn-danger',
                                                keys: ['enter'],
                                                action: () => {
                                                    if (grid.getEditorLock().isActive()) {
                                                        grid.getEditorLock().cancelCurrentEdit();
                                                    }
                                                    currentAttribute.update(attribute);

                                                    dataView.beginUpdate();
                                                    dataView.updateItem(currentAttribute.id, currentAttribute.clone());
                                                    dataView.endUpdate();

                                                    grid.setSelectedRows([args.row]);
                                                    grid.setActiveCell(args.row, args.cell);
                                                }
                                            },
                                            cancel: function () {

                                            }
                                        }
                                    });
                                    e.preventDefault();
                                    e.stopImmediatePropagation();
                                }
                            } else {
                                Utils.$.confirm({
                                    title: 'Confirm?',
                                    keyboardEnabled: true,
                                    escapeKey: 'cancel',
                                    backgroundDismiss: false,
                                    content: 'There are unsaved changes. Are you sure you want to continue?',
                                    type: 'red',
                                    theme: 'dark',
                                    typeAnimated: false,
                                    buttons: {
                                        ok: {
                                            text: "Yes!",
                                            btnClass: 'btn-danger',
                                            keys: ['enter'],
                                            action: () => {
                                                if (grid.getEditorLock().isActive()) {
                                                    grid.getEditorLock().cancelCurrentEdit();
                                                }
                                                dataView.beginUpdate();
                                                dataView.deleteItem(-1);
                                                dataView.endUpdate();
                                                grid.setSelectedRows([args.row - 1]);
                                                grid.setActiveCell(args.row - 1, args.cell);
                                                BusinessObject.enableButton("attributes-new-btn");
                                            }
                                        },
                                        cancel: function () {

                                        }
                                    }
                                });
                                e.preventDefault();
                                e.stopImmediatePropagation();
                            }
                        }
                    };

                    grid.onBeforeEditCell.subscribe(function (e, args) {
                            const item = dataView.getItem(args.row);
                            const currentBusinessObject = getCurrentBusinessObject();
                            const originalAttribute = currentBusinessObject.getAttribute(item.id);
                            if (item.name === "Name") {
                                if (item.systemRequired && args.column.field !== "systemRequired") {
                                    toastr.warning("The system required attribute can not be edited.");
                                    return false;
                                }
                                if (args.column.field === "name") {
                                    toastr.warning("Attribute name can not be edited");
                                    return false;
                                }
                            }
                            if (args.column.field !== "systemRequired" && (originalAttribute && originalAttribute.systemRequired)) {
                                toastr.warning("The attribute you are trying to edit is required for the system. Please set System Required to false and save it to continue editing.");
                                return false
                            }
                            switch (item.type) {
                                case AttributeTypeEnum.JSON:
                                case AttributeTypeEnum.TEXT:
                                case AttributeTypeEnum.INT: {
                                    switch (args.column.id) {
                                        case "maxDigitsLeftOfDecimal":
                                        case "minDigitsRightOfDecimal":
                                        case "receiveNotifications": {
                                            return false;
                                        }
                                    }
                                }
                                    break;
                                case AttributeTypeEnum.EMAIL: {
                                    switch (args.column.id) {
                                        case "minLength":
                                        case "maxLength":
                                        case "maxDigitsLeftOfDecimal":
                                        case "minDigitsRightOfDecimal":
                                        case "regexValidation":
                                            return false;
                                    }
                                    break;
                                }
                                case AttributeTypeEnum.VALUE_LIST: {
                                    switch (args.column.id) {
                                        case "minLength":
                                        case "maxLength":
                                        case "maxDigitsLeftOfDecimal":
                                        case "minDigitsRightOfDecimal":
                                        case "regexValidation":
                                        case "receiveNotifications":
                                            return false;
                                    }
                                    if (item.attributeValues.size === 0 && args.column.field === "defaultValue") {
                                        return false;
                                    }
                                }
                                    break;
                                case AttributeTypeEnum.DATE:
                                case AttributeTypeEnum.TIME:
                                case AttributeTypeEnum.TIMESTAMP: {
                                    switch (args.column.id) {
                                        case "minLength":
                                        case "maxLength":
                                        case "maxDigitsLeftOfDecimal":
                                        case "minDigitsRightOfDecimal":
                                        case "receiveNotifications":
                                            return false;
                                    }
                                }
                                    break;
                                case AttributeTypeEnum.INCREMENTING:
                                case AttributeTypeEnum.LOOKUP:{
                                    switch (args.column.id) {
                                        case "defaultValue":
                                        case "receiveNotifications":
                                        case "regexValidation":
                                            return false;
                                    }
                                }
                                    break;
                                case AttributeTypeEnum.DECIMAL:
                                    switch (args.column.id) {
                                        case "receiveNotifications":
                                            return false;
                                    }
                                    break;
                                case AttributeTypeEnum.BOOLEAN:
                                    switch (args.column.id) {
                                        case "minLength":
                                        case "maxLength":
                                        case "maxDigitsLeftOfDecimal":
                                        case "minDigitsRightOfDecimal":
                                        case "receiveNotifications": {
                                            return false;
                                        }
                                    }
                                    break;
                            }
                            return true;
                        }
                    );

                    grid.onKeyDown.subscribe((event) => {
                        if (event.keyCode === 9 && event.shiftKey === false) {
                            if (grid.getActiveCell().cell === lastEditableCol) {
                                if (!$("#attributes-save-btn").prop("disabled")) {
                                    this.saveBoClassAttribute(true);
                                } else {
                                    grid.gotoCell(grid.getActiveCell().row, firstEditableCol, true);
                                }
                                event.stopImmediatePropagation();
                            }
                        }
                        if (event.keyCode === 9 && event.shiftKey === true) {
                            if (grid.getActiveCell().cell === firstEditableCol) {
                                grid.gotoCell(grid.getActiveCell().row, lastEditableCol, true);
                                event.stopImmediatePropagation();
                            }
                        }
                        if (event.keyCode === 13) {
                            grid.getEditController().commitCurrentEdit();
                            event.stopImmediatePropagation();
                        }
                    });

                    grid.onClick.subscribe(function (e, args) {
                        if (grid.getEditorLock().isActive()) {
                            grid.getEditorLock().commitCurrentEdit();
                        }
                        const row = grid.getSelectedRows()[0];
                        if (row !== args.row) {
                            grid.setSelectedRows([args.row]);
                        }
                    });

                    grid.onValidationError.subscribe(function (e, args) {
                        toastr.warning(args.validationResults.msg)
                    });

                    Utils.$("#attributes-new-btn")
                        .unbind()
                        .click(function () {
                            removeFilters();
                            const currentAttribute = getCurrentAttribute();
                            const currentBusinessObject = getCurrentBusinessObject();
                            if (currentAttribute) {
                                if (currentBusinessObject.hasAttribute(currentAttribute.id)) {
                                    const attribute = currentBusinessObject.getAttribute(currentAttribute.id);
                                    if (!attribute.equal(currentAttribute)) {
                                        Utils.$.confirm({
                                            title: 'Confirm?',
                                            keyboardEnabled: true,
                                            escapeKey: 'cancel',
                                            backgroundDismiss: false,
                                            content: 'There are unsaved changes. Are you sure you want to continue?',
                                            type: 'red',
                                            theme: 'dark',
                                            typeAnimated: false,
                                            buttons: {
                                                ok: {
                                                    text: "Yes!",
                                                    btnClass: 'btn-danger',
                                                    keys: ['enter'],
                                                    action: () => {
                                                        newRow();
                                                    }
                                                },
                                                cancel: function () {
                                                }
                                            }
                                        });
                                    } else {
                                        newRow();
                                    }
                                }
                            } else {
                                newRow();
                            }

                            function newRow() {
                                addNewRow(grid, currentBusinessObject);
                            }
                        });
                    Utils.$("#attributes-save-btn")
                        .unbind()
                        .click(() => {
                            this.saveBoClassAttribute(false);
                        });
                    Utils.$("#attributes-delete-btn")
                        .unbind()
                        .click(() => {
                            const row = grid.getSelectedRows()[0];
                            const item = dataView.getItem(row);
                            if (item) {
                                const currentAttribute = getCurrentAttribute();
                                const currentBusinessObject = getCurrentBusinessObject();
                                if (currentBusinessObject.hasAttribute(currentAttribute.id)) {
                                    const isErasable = currentAttribute.isErasable(currentBusinessObject);
                                    if (!isErasable.erasable) {
                                        toastr.warning(isErasable.msg);
                                        return;
                                    }
                                    if (currentAttribute.name === "Name") {
                                        toastr.warning(`You cannot delete ${currentAttribute.name} attribute.`);
                                        return;
                                    }
                                    Utils.$.confirm({
                                        title: 'Confirm?',
                                        keyboardEnabled: true,
                                        escapeKey: 'cancel',
                                        backgroundDismiss: false,
                                        content: 'You are about to delete one attribute, this procedure is irreversible.',
                                        type: 'red',
                                        theme: 'dark',
                                        typeAnimated: false,
                                        buttons: {
                                            ok: {
                                                text: "Yes!",
                                                btnClass: 'btn-danger',
                                                keys: ['enter'],
                                                action: () => {
                                                    this.props.deleteBusinessObjectAttribute(currentAttribute.id, {
                                                        boClass: currentBusinessObject,
                                                        event: EVENTS.boView.attributesGrid.delete
                                                    });
                                                }
                                            },
                                            cancel: function () {
                                            }
                                        }
                                    });
                                } else {
                                    const row = dataView.getRowById(currentAttribute.id);
                                    dataView.beginUpdate();
                                    dataView.deleteItem(currentAttribute.id);
                                    dataView.endUpdate();
                                    grid.invalidateRow(row);
                                    grid.setSelectedRows([row]);
                                    grid.render();
                                    BusinessObject.enableButton("attributes-new-btn");
                                }
                            }
                        });

                    new Slick.Controls.ColumnPicker(columns, grid, options);
                    grid.setSelectionModel(new Slick.RowSelectionModel({selectActiveRow: false}));
                    dataView.syncGridSelection(grid, true, false);
                    grid.init();
                    if (dataView.getLength() === 0) {
                        addNewRow(grid, businessObject);
                    }
                    grid.setSelectedRows([dataView.getRowById(attrId) | 0]);
                    attachAutoResizeDataGrid(grid, "BusinessObjectAttributesGrid");
                    BusinessObject.enableButton("attributes-new-btn");
                    this.setState({grid});
                }
            }
        );
    };

    onLookUpConfig = () => {
        this.lookUpConfigRef.open(this.props.currentAttribute.lookupAttributeId, this.props.currentAttribute.lookupRelTypeId, this.props.currentAttribute.createRelationships, this.props.currentBusinessObject.id);
    };

    saveBoClassAttribute = (withNewRow) => {
        const currentAttribute = this.props.currentAttribute;
        const currentBusinessObject = this.props.currentBusinessObject;
        const result = currentBusinessObject.checkAttributesBeforeSave(currentAttribute);
        if (result.valid) {
            if (this.state.grid.getEditorLock().isActive()) {
                this.state.grid.getEditorLock().commitCurrentEdit();
            }
            const dto = {
                name: currentAttribute.name,
                description: currentAttribute.description,
                type: currentAttribute.type,
                unitOfMeasure: currentAttribute.unitOfMeasure,
                minLength: currentAttribute.minLength,
                maxLength: currentAttribute.maxLength,
                maxDigitsLeftOfDecimal: currentAttribute.maxDigitsLeftOfDecimal,
                minDigitsRightOfDecimal: currentAttribute.minDigitsRightOfDecimal,
                regexValidation: currentAttribute.regexValidation,
                uiSection: currentAttribute.uiSection,
                sequence: 10,
                suffix: currentAttribute.suffix,
                prefix: currentAttribute.prefix,
                receiveNotifications: currentAttribute.receiveNotifications,
                boClass: {
                    id: currentBusinessObject.id,
                    name: currentBusinessObject.name,
                    description: currentBusinessObject.description,
                    instanceCount: currentBusinessObject.instancesCount
                },
                required: currentAttribute.required,
                systemRequired: currentAttribute.systemRequired,
            };
            switch (currentAttribute.type) {
                case AttributeTypeEnum.TIME:
                    const offset = Utils.moment(`${Utils.moment().format("YYYY-MM-DD")} ${currentAttribute.defaultValue}`).utcOffset() / 60;
                    dto["defaultValue"] = Utils.moment(`${Utils.moment().format("YYYY-MM-DD")} ${currentAttribute.defaultValue}`).subtract(offset, "h").format("HH:mm:ss");
                    break;
                case AttributeTypeEnum.TIMESTAMP:
                    dto["defaultValue"] = Utils.moment_timezone.tz(currentAttribute.defaultValue, Utils.moment_timezone(currentAttribute.defaultValue).creationData().format, Utils.timezone).utc().format(moment(currentAttribute.defaultValue).creationData().format);
                    break;
                case AttributeTypeEnum.LOOKUP:
                    dto["defaultValue"] = currentAttribute.defaultValue;
                    dto["lookupRelTypeId"] = currentAttribute.lookupRelTypeId;
                    dto["lookupAttributeId"] = currentAttribute.lookupAttributeId;
                    dto["createRelationships"] = currentAttribute.createRelationships;
                    break;
                default:
                    dto["defaultValue"] = currentAttribute.defaultValue;
            }
            if (currentAttribute.id === -1) {
                this.props.createBusinessObjectAttribute(dto, {
                    withNewRow,
                    boClass: dto.boClass,
                    event: EVENTS.boView.attributesGrid.create
                });
            } else {
                delete dto["sequence"];
                this.props.updateBusinessObjectAttribute(currentAttribute.id, dto, {
                    boClass: currentBusinessObject,
                    event: EVENTS.boView.attributesGrid.update
                });
            }
        } else {
            BusinessObject.disableButton("attributes-save-btn");
            BusinessObjects.appendQtipsToNode(result.data, this.state.grid, $("#attributes-save-btn"));
        }
    };

    onIncrementingConfig = () => {
        if (this.state.grid.getEditorLock().isActive()) {
            this.state.grid.getEditorLock().commitCurrentEdit();
        }
        const originalAttribute = this.props.currentBusinessObject.getAttribute(this.props.currentAttribute.id);
        if (originalAttribute.type !== this.props.currentAttribute.type) {
            this.saveBoClassAttribute(false);
        }
        this.incrementingConfigRef.open(this.props.currentAttribute);
    };

    onSetLookUpConfig = (config: any) => {
        this.lookUpConfigRef.close();
        this.props.currentAttribute.createRelationships = config.createRelationships;
        this.props.currentAttribute.lookupAttributeId = config.defaultAttribute ? config.defaultAttribute.value : null;
        this.props.currentAttribute.lookupRelTypeId = config.defaultRelationship ? config.defaultRelationship.value : null;

        const originalAttribute = this.props.currentBusinessObject.getAttribute(this.props.currentAttribute.id);
        if (!this.props.currentAttribute.equal(originalAttribute)) {
            BusinessObject.enableButton("attributes-save-btn", "");
        } else {
            BusinessObject.disableButton("attributes-save-btn", "There is no changes.");
        }
    };

    onSetIncrementing = (attribute: any) => {
        const grid = $("#BusinessObjectAttributesGrid").data("gridInstance");
        const dataView = grid.getData();
        dataView.beginUpdate();
        dataView.updateItem(attribute.id, attribute);
        dataView.endUpdate();
        this.props.currentAttribute.prefix = attribute.prefix;
        this.props.currentAttribute.suffix = attribute.suffix;
    };

    onConvertAttribute = (currentAttribute: any, currentBusinessObject: any) => {
        this.props.convertBusinessObjectAttributeType(currentAttribute.id, { targetAttributeType: currentAttribute._type }, {
            boClass: currentBusinessObject,
            event: EVENTS.boView.attributesGrid.update
        });
    };

    render() {
        const {currentBusinessObject} = this.props;
        if (!currentBusinessObject) return null;

        let convertAttributeTypeAvailable = false, originalAttribute = null;
        const currentAttribute = this.props.currentAttribute;
        if (currentAttribute) {
            originalAttribute = currentBusinessObject.getAttribute(currentAttribute.id);
            convertAttributeTypeAvailable = originalAttribute && currentAttribute && currentAttribute.id !== -1
                && Utils.isAttributeTypeConvertibleTo(originalAttribute.type, currentAttribute.type);
        }

        return (
            <div>
                <div className="bo-core-header background-gradient" style={{marginBottom: 5, paddingTop: 5}}>
                    <label style={
                        {
                            marginLeft: 2,
                            float: "left",
                            color: "#FFFFFF",
                            paddingTop: 7,
                            fontSize: 18,
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden"
                        }
                    }
                           title={`Attributes (fields) From Type: ${currentBusinessObject.name}`}
                    >
                        {`Attributes (fields) From Type: ${currentBusinessObject.name}`}
                    </label>
                    <div style={{float: "right", display: "flex"}}>
                        {this.props.currentAttribute && this.props.currentAttribute.type === AttributeTypeEnum.LOOKUP ?
                            <button onClick={this.onLookUpConfig.bind(this)} style={{marginRight: 2, height: 36}}
                                    className="btn btn-success">LookUp Config
                            </button>
                            : null}
                        {this.props.currentAttribute && this.props.currentAttribute.id !== -1 && this.props.currentAttribute.type === AttributeTypeEnum.INCREMENTING ?
                            <button onClick={this.onIncrementingConfig.bind(this)} style={{marginRight: 2, height: 36}}
                                    className="btn btn-success">Incrementing Config
                            </button>
                            : null}
                        {convertAttributeTypeAvailable ?
                            <button onClick={() => this.onConvertAttribute(currentAttribute, currentBusinessObject)} style={{marginRight: 2, height: 36, border: "solid red 1px"}}
                                    className="btn btn-warning">Perform Attribute Type Conversion
                            </button>
                            : null
                        }
                        <button style={{marginRight: 2, height: 36}} id="attributes-new-btn"
                                className="btn btn-success">New
                        </button>
                        <button style={{marginRight: 2, height: 36}} title="There is no changes."
                                id="attributes-save-btn"
                                className="btn btn-primary">Save
                        </button>
                        <button style={{marginRight: 2, height: 36}} id="attributes-delete-btn"
                                className="btn btn-danger">Delete
                        </button>
                    </div>
                </div>
                <div className="custom-header" style={{border: "0px", backgroundColor: "#FFFFFF"}}
                     id="BusinessObjectAttributesGrid"/>
                <LookUpConfigModal
                    onRef={(ref) => {
                        this.lookUpConfigRef = ref
                    }}
                    onSet={this.onSetLookUpConfig.bind(this)}
                />
                <IncrementingConfigModal
                    onRef={(ref) => {
                        this.incrementingConfigRef = ref
                    }}
                    onSet={this.onSetIncrementing.bind(this)}/>
            </div>
        )
    }
}

function addNewRow(grid, businessObject) {
    if (businessObject.systemRequired) {
        Utils.$.confirm({
            title: 'Confirm?',
            keyboardEnabled: true,
            escapeKey: 'cancel',
            backgroundDismiss: false,
            content: 'Adding attributes to a system class may cause problems. Are you sure you want to continue?',
            type: 'red',
            theme: 'dark',
            typeAnimated: false,
            buttons: {
                ok: {
                    text: "Yes!",
                    btnClass: 'btn-danger',
                    keys: ['enter'],
                    action: () => {
                        add();
                    }
                },
                cancel: function () {
                }
            }
        });
    } else {
        add();
    }

    function add() {
        const dataView = grid.getData();
        dataView.beginUpdate();
        dataView.insertItem(0, new Attribute(-1, "", "n/a", "n/a", AttributeTypeEnum.TEXT, -1, -1, -1, -1, ".*", "main", "n/a", "n/a", null, {
            id: businessObject.id,
            name: businessObject.name,
            description: businessObject.description
        }, [], true, false, "n/a", null, false, null));
        dataView.endUpdate();
        $("#attributes-new-btn").prop("disabled", true);
        grid.setSelectedRows([0]);
        grid.setActiveCell(0, 1);
    }
}

function PopulateSelect(select, dataSource, addBlank) {
    if (addBlank) {
        select.appendChild(new Option('', ''));
    }
    if (dataSource && dataSource.length > 0) {
        dataSource.sort(function(a, b){
            if(a.toLowerCase() < b.toLowerCase()) { return -1; }
            if(a.toLowerCase() > b.toLowerCase()) { return 1; }
            return 0;
        });
    }
    $.each(dataSource, function (value, text) {
        select.appendChild(new Option(text, text));
    });
}

function PopulateDefaultSelect(select, dataSource) {
    $.each(dataSource, function (value, text) {
        select.appendChild(new Option(text.name, text.id));
    });
}

const mapStateToProps = (state, ownProps) => {
    return {
        currentBusinessObject: ownProps.currentBusinessObject,
        currentAttribute: ownProps.currentAttribute
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        createBusinessObjectAttribute: (attribute, args) => {
            dispatch(createBusinessObjectAttribute(attribute, args))
        },
        updateBusinessObjectAttribute: (id, dto, args) => {
            dispatch(updateBusinessObjectAttribute(id, dto, args))
        },
        convertBusinessObjectAttributeType: (id, dto, args) => {
            dispatch(convertBusinessObjectAttributeType(id, dto, args))
        },
        deleteBusinessObjectAttribute: (id, args) => {
            dispatch(deleteBusinessObjectAttribute(id, args))
        }
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(BusinessObjectBusinessObjectAttributesGrid)



// WEBPACK FOOTER //
// ./app/components/bo-core/grids/BusinessObjectAttributesGrid.tsx